// Protocol component
import ProtocolWorkspace from "@/components/protocolEditor/Workspace.vue";
import ProtocolGate from "@/components/protocolEditor/Gateway.vue";
import ProtocolEditor from "@/components/protocolEditor/Editor.vue";
import Equiments from "@/components/protocolEditor/Equiments.vue";

const ProtocolRoute =   {
  path:'/protocol',
  component: ProtocolWorkspace,
  meta: { requireAuth: true },
  children: [
    {
      path:'/protocol/gate',
      name:'ProtocolGateway',
      component: ProtocolGate,
    },
    {
      path:'/protocol/editor',
      name:'ProtocolEditor',
      component: ProtocolEditor, 
    },
    {
      path:'/protocol/equiment',
      name:'ProtocolEquiment',
      component: Equiments,
    },
  ]
} ; 
export default ProtocolRoute ;
